import {TcddWagonTitle} from '../enums/index-map/tcdd-wagon-title.enum';
import {TcddSubSystemName} from '../enums/tcdd-sub-system-name.enum';
import {PathInfo} from '../models/tcdd-train/path-info.model';
import {TcddSubSystem} from '../enums/tcdd-sub-system.enum';
import {TcddDialogView} from '../enums/tcdd-dialog-view.enum';
import {TCDD_UNIT} from '../constants/tcdd-unit-constant';

interface SystemConfig {
  default: PathInfo;
  specifics: Record<string, PathInfo>;
}

type Handler = (id: string) => { path: string; path_3D?: string; pathTitle?: string; view: TcddDialogView; selectedTitle: string };

// Centralized configuration for all systems
const systemConfigs: Record<TcddSubSystemName, SystemConfig> = {
  [TcddSubSystemName.TRACTION]: {
    default: {path: 'assets/images/train/train-traction-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TCDD_UNIT.CESUR]: {path: 'assets/images/train/unit-cesur.svg', pathTitle: 'cesur-cer-inverter-and-apu-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.CER_MOTOR]: {path: 'assets/images/train/unit-cer-motor.svg', pathTitle: 'cer-motor-title', view: TcddDialogView.UNIT_VISUAL},
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-traction.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-traction.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.SIGNALIZATION]: {
    default: {path: 'assets/images/train/train-signalization-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TCDD_UNIT.DMI]: {
        path: 'assets/images/train/unit-dmi.svg', path_3D: 'https://assets.geleceginsehri.com/glb/DMI.glb',
        pathTitle: 'dmi-title',
        view: TcddDialogView.UNIT_DETAIL
      },
      [TCDD_UNIT.ETCS_CAB_1]: {path: 'assets/images/train/unit-etcs-cab-1.svg', pathTitle: 'etcs-cab-1-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.ETCS_CAB_2]: {path: 'assets/images/train/unit-etcs-cab-2.svg', pathTitle: 'etcs-cab-2-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.GSM_R_ANTENNA_DATA_1]: {path: 'assets/images/train/unit-gsm-r-antenna.svg', pathTitle: 'gsm-r-antenna-data-1-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.GSM_R_ANTENNA_DATA_2]: {path: 'assets/images/train/unit-gsm-r-antenna.svg', pathTitle: 'gsm-r-antenna-data-2-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.GSM_R_ANTENNA_VOICE]: {path: 'assets/images/train/unit-gsm-r-antenna.svg', pathTitle: 'gsm-r-antenna-voice-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.TACHOMETER_SPEED_SENSOR]: {path: 'assets/images/train/unit-tachometer-speed-sensor.svg', pathTitle: 'tachometer-speed-sensor-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.DOPPLER_RADAR]: {
        path: 'assets/images/train/unit-doppler-radar.svg', path_3D: 'https://assets.geleceginsehri.com/glb/Doppler-Radar.glb',
        pathTitle: 'doppler-radar-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CABINET_1_RTM]: {path: 'assets/images/train/unit-rtm.svg', pathTitle: 'rtm-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.CABINET_1_GSM_R_VOICE_MODULE]: {path: 'assets/images/train/unit-gsm-r-voice-module.svg', pathTitle: 'gsm-r-voice-module-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.CABINET_2_JRU]: {
        path: 'assets/images/train/unit-jru.svg', path_3D: 'https://assets.geleceginsehri.com/glb/JRU.glb',
        pathTitle: 'jru-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CABINET_2_PSU]: {
        path: 'assets/images/train/unit-psu.svg', path_3D: 'https://assets.geleceginsehri.com/glb/PSU.glb',
        pathTitle: 'psu-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CABINET_2_EVC]: {
        path: 'assets/images/train/unit-evc.svg', path_3D: 'https://assets.geleceginsehri.com/glb/EVC.glb',
        pathTitle: 'evc-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CABINET_2_NVC]: {
        path: 'assets/images/train/unit-nvc.svg', path_3D: 'https://assets.geleceginsehri.com/glb/NVC.glb',
        pathTitle: 'nvc-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CABINET_2_BTM]: {path: 'assets/images/train/unit-btm.svg', pathTitle: 'btm-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.BTM_ANTENNA]: {path: 'assets/images/train/unit-btm-antenna.svg', pathTitle: 'btm-antenna-title', view: TcddDialogView.UNIT_VISUAL},
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-signalization.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-signalization.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.COMMUNICATION]: {
    default: {path: 'assets/images/train/train-communication-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TCDD_UNIT.UDS_UIB]: {
        path: 'assets/images/train/unit-uds-uib.svg', path_3D: 'https://assets.geleceginsehri.com/glb/UIB.glb',
        pathTitle: 'uds-uib-title',
        view: TcddDialogView.UNIT_DETAIL
      },
      [TCDD_UNIT.BTM]: {path: 'assets/images/train/unit-btm.svg', pathTitle: 'btm-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.JRU]: {
        path: 'assets/images/train/unit-jru.svg', path_3D: 'https://assets.geleceginsehri.com/glb/JRU.glb',
        pathTitle: 'jru-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.RTM]: {path: 'assets/images/train/unit-rtm.svg', pathTitle: 'rtm-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.EVC]: {
        path: 'assets/images/train/unit-evc.svg', path_3D: 'https://assets.geleceginsehri.com/glb/EVC.glb',
        pathTitle: 'evc-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.NVC]: {
        path: 'assets/images/train/unit-nvc.svg', path_3D: 'https://assets.geleceginsehri.com/glb/NVC.glb',
        pathTitle: 'nvc-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.DMI]: {
        path: 'assets/images/train/unit-dmi.svg', path_3D: 'https://assets.geleceginsehri.com/glb/DMI.glb',
        pathTitle: 'dmi-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CCU_UNIT]: {
        path: 'assets/images/train/unit-ccu.svg', path_3D: 'https://assets.geleceginsehri.com/glb/CCU.glb',
        pathTitle: 'ccu-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.RIOM_1_CCU]: {
        path: 'assets/images/train/unit-riom-ccu.svg', path_3D: 'https://assets.geleceginsehri.com/glb/RIOM-CCU.glb',
        pathTitle: 'riom-ccu-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.RIOM_2_CCU]: {
        path: 'assets/images/train/unit-riom-ccu.svg', path_3D: 'https://assets.geleceginsehri.com/glb/RIOM-CCU.glb',
        pathTitle: 'riom-ccu-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.CCU]: {path: 'assets/images/train/unit-ccu-container.svg', pathTitle: 'ccu-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.TCU]: {
        path: 'assets/images/train/unit-tcu.svg', path_3D: 'https://assets.geleceginsehri.com/glb/TCU.glb',
        pathTitle: 'tcu-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.OA_RIOM_1]: {
        path: 'assets/images/train/unit-oa-riom-1.svg', path_3D: 'https://assets.geleceginsehri.com/glb/OA-RIOM-1.glb',
        pathTitle: 'oa-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.OA_RIOM_2]: {
        path: 'assets/images/train/unit-oa-riom-2.svg', path_3D: 'https://assets.geleceginsehri.com/glb/OA-RIOM-2.glb',
        pathTitle: 'oa-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.OA3_RIOM_1]: {
        path: 'assets/images/train/unit-oa-riom-2.svg', path_3D: 'https://assets.geleceginsehri.com/glb/OA-RIOM-2.glb',
        pathTitle: 'oa-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.OA3_RIOM_2]: {
        path: 'assets/images/train/unit-oa-riom-3.svg', path_3D: 'https://assets.geleceginsehri.com/glb/OA-RIOM-3.glb',
        pathTitle: 'oa-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.SKA_RIOM_1]: {
        path: 'assets/images/train/unit-ska-riom-1.svg', path_3D: 'https://assets.geleceginsehri.com/glb/SKA-RIOM-1.glb',
        pathTitle: 'ska-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.SKA_RIOM_2]: {
        path: 'assets/images/train/unit-ska-riom-2.svg', path_3D: 'https://assets.geleceginsehri.com/glb/SKA-RIOM-2.glb',
        pathTitle: 'ska-riom-title',
        view: TcddDialogView.UNIT_VISUAL
      },
      [TCDD_UNIT.OA1_CAN_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA1_MVB_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA1_1_CAN_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA1_1_MVB_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA2_CAN_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA2_MVB_RIOM]: {path: 'assets/images/train/unit-riom-oa-container.svg', pathTitle: 'riom-oa-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA3_CAN_RIOM]: {path: 'assets/images/train/unit-riom-oa3-container.svg', pathTitle: 'riom-oa3-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.OA3_MVB_RIOM]: {path: 'assets/images/train/unit-riom-oa3-container.svg', pathTitle: 'riom-oa3-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.CAN_RIOM]: {path: 'assets/images/train/unit-riom-ska-container.svg', pathTitle: 'riom-ska-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.MVB_RIOM]: {path: 'assets/images/train/unit-riom-ska-container.svg', pathTitle: 'riom-ska-title', view: TcddDialogView.UNIT_VISUAL},
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-communication.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-communication.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.BRAKE]: {
    default: {path: 'assets/images/train/train-brake-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TCDD_UNIT.BRAKE_TB]: {path: 'assets/images/train/unit-not-motorized-bogie.svg', pathTitle: 'not-motorized-bogie-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.BRAKE_MB]: {path: 'assets/images/train/unit-motorized-bogie.svg', pathTitle: 'motorized-bogie-title', view: TcddDialogView.UNIT_VISUAL},
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-brake.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-brake.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.POWER_VOLTAGE]: {
    default: {path: 'assets/images/train/train-powervoltage-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TCDD_UNIT.BATTERY]: {path: 'assets/images/train/unit-battery.svg', pathTitle: 'battery-title', view: TcddDialogView.UNIT_VISUAL},
      [TCDD_UNIT.TRANSFORMER]: {path: 'assets/images/train/unit-transformer.svg', pathTitle: 'transformer-title', view: TcddDialogView.UNIT_VISUAL},
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-powervoltage.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.AIR_CONDITION]: {
    default: {path: 'assets/images/train/train-aircondition-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-aircondition.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-aircondition.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.DOOR]: {
    default: {path: 'assets/images/train/train-door-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-door.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-door.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  },
  [TcddSubSystemName.OTHER]: {
    default: {path: 'assets/images/train/train-other-6-wagons.svg', view: TcddDialogView.TRAIN_OVERVIEW},
    specifics: {
      [TcddWagonTitle.SKA1]: {path: 'assets/images/train/ska1-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.SKA2]: {path: 'assets/images/train/ska2-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_1]: {path: 'assets/images/train/oa1_1-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1_2]: {path: 'assets/images/train/oa1_2-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA1]: {path: 'assets/images/train/oa1-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA2]: {path: 'assets/images/train/oa2-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA3]: {path: 'assets/images/train/oa3-other.svg', view: TcddDialogView.WAGON_DETAIL},
      [TcddWagonTitle.OA4]: {path: 'assets/images/train/oa4-other.svg', view: TcddDialogView.WAGON_DETAIL}
    }
  }
};

export class SvgTcddTrainClickHandlers {
  private static createSystemHandler(system: TcddSubSystemName): Handler {
    const {default: defaultInfo, specifics} = systemConfigs[system];
    return (id: string) => {
      for (const key of Object.keys(specifics)) {
        if (id.includes(key)) {
          const {path, path_3D, pathTitle, view} = specifics[key];
          return {path, path_3D, pathTitle, view, selectedTitle: key};
        }
      }
      return {path: defaultInfo.path, path_3D: '', pathTitle: '', view: defaultInfo.view, selectedTitle: id};
    };
  }

  public static getHandlers() {
    return {
      [TcddSubSystem.TRACTION_SYSTEM]: this.createSystemHandler(TcddSubSystemName.TRACTION),
      [TcddSubSystem.SIGNALIZATION_SYSTEM]: this.createSystemHandler(TcddSubSystemName.SIGNALIZATION),
      [TcddSubSystem.COMMUNICATION_SYSTEM]: this.createSystemHandler(TcddSubSystemName.COMMUNICATION),
      [TcddSubSystem.BRAKE_SYSTEM]: this.createSystemHandler(TcddSubSystemName.BRAKE),
      [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: this.createSystemHandler(TcddSubSystemName.POWER_VOLTAGE),
      [TcddSubSystem.AIR_CONDITION_SYSTEM]: this.createSystemHandler(TcddSubSystemName.AIR_CONDITION),
      [TcddSubSystem.DOOR_SYSTEM]: this.createSystemHandler(TcddSubSystemName.DOOR),
      [TcddSubSystem.OTHER_SYSTEM]: this.createSystemHandler(TcddSubSystemName.OTHER)
    };
  }
}
